/* Kiddoz Kitchen — Mobile Menu Drawer controller
   Vanilla JS, no dependencies. Hooks into the existing hamburger
   button (selector [data-mobile-menu]) already present in the theme header. */
(function () {
  'use strict';

  function initMobileMenuDrawer() {
    var root = document.querySelector('[data-mm-root]');
    var toggleBtn = document.querySelector('[data-mobile-menu]');
    if (!root || !toggleBtn) return;

    var overlay = root.querySelector('[data-mm-overlay]');
    var closeButtons = root.querySelectorAll('[data-mm-close]');
    var backButtons = root.querySelectorAll('[data-mm-back]');
    var openTriggers = root.querySelectorAll('[data-mm-open-panel]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.mm-panel'));
    var titleEl = root.querySelector('[data-mm-title]');
    var drawerEl = root.querySelector('.mm-drawer');

    var stack = [panels[0]];
    var lastFocused = null;

    function setTitle(panel) {
      if (!titleEl) return;
      titleEl.textContent = panel.getAttribute('data-mm-panel-title') || 'Menu';
    }

    function syncChrome() {
      var current = stack[stack.length - 1];
      setTitle(current);
      drawerEl.setAttribute('data-active-root', stack.length === 1 ? 'true' : 'false');
      panels.forEach(function (p) {
        var active = p === current;
        p.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function goTo(targetId) {
      var target = root.querySelector('#' + targetId);
      if (!target) return;
      var current = stack[stack.length - 1];
      current.setAttribute('data-state', 'prev');
      target.setAttribute('data-state', 'active');
      stack.push(target);
      syncChrome();
      var heading = target.querySelector('h2,[data-mm-panel-title-el]');
      if (heading) heading.setAttribute('tabindex', '-1'), heading.focus({ preventScroll: true });
    }

    function goBack() {
      if (stack.length < 2) return;
      var current = stack.pop();
      var prev = stack[stack.length - 1];
      current.setAttribute('data-state', 'next');
      prev.setAttribute('data-state', 'active');
      syncChrome();
    }

    function resetStack() {
      panels.forEach(function (p, i) {
        p.setAttribute('data-state', i === 0 ? 'active' : 'next');
      });
      stack = [panels[0]];
      syncChrome();
    }

    function open() {
      lastFocused = document.activeElement;
      root.classList.add('is-open');
      document.body.classList.add('mm-scroll-lock');
      document.addEventListener('keydown', onKeydown);
      var closeBtn = root.querySelector('[data-mm-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('mm-scroll-lock');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(resetStack, 320);
      if (lastFocused) lastFocused.focus();
      if (document.body.classList.contains('menu_open')) {
        document.body.classList.remove('menu_open');
      }
    }

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key === 'Tab') trapFocus(e);
    }

    function trapFocus(e) {
      var focusable = drawerEl.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }

    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      isOpen() ? close() : open();
    });

    overlay && overlay.addEventListener('click', close);
    closeButtons.forEach(function (b) { b.addEventListener('click', close); });
    backButtons.forEach(function (b) { b.addEventListener('click', goBack); });
    openTriggers.forEach(function (b) {
      b.addEventListener('click', function () {
        goTo(b.getAttribute('data-mm-open-panel'));
      });
    });

    resetStack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuDrawer);
  } else {
    initMobileMenuDrawer();
  }
})();
